export default __webpack_public_path__ + "static/media/SubscriptionValues.23015bef.svg";